import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ICreateDiscountTemplatesDto, IDiscountTemplatesDto, IPagedCustomizedDiscountTemplateResultRequestDto, IPagedDiscountTemplateResultRequestDto, IPagedGeneralDiscountTemplateResultRequestDto, IUpdateDiscountTemplatesDto } from 'src/app/models/backend';
import { ICreateCustomizedDiscountTemplatesDto, IUpdateCustomizedDiscountTemplatesDto } from 'src/app/models/backend/customized-discount-template';
import { ICreateGeneralDiscountTemplatesDto, IGeneralDiscountTemplatesDto, IUpdateGeneralDiscountTemplatesDto } from 'src/app/models/backend/general-discount-templates';
import { PagedResultDto } from 'src/app/shared/components/paged-listing-component-base';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DiscountTemplatesService {
  id: any;

  templateId: any

  constructor(private http: HttpClient) { }

  readonly url = environment.apiUrl+'DiscountTemplates/';
  readonly generalurl = environment.apiUrl+'DiscountTemplateGenerals/';
  readonly customurl = environment.apiUrl+'DiscountTemplateCustomized/';
  readonly dingUrl = environment.apiUrl+'Ding/';
  readonly productUrl = environment.apiUrl+'Products/';

  Token = localStorage.getItem("Token")
  headers = new HttpHeaders()
  .set('Content-Type', 'application/json; charset=utf-8')
  .set('Authorization', `Bearer ${this.Token}`);

  // headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

  CreateDiscountTemplate(CreateProductDto: ICreateDiscountTemplatesDto) {
    return this.http.post<ICreateDiscountTemplatesDto>(this.url + 'CreateDiscountTemplate',
      CreateProductDto, { headers: this.headers })
  }
  UpdateDiscountTemplate(payload: IUpdateDiscountTemplatesDto): Observable<IDiscountTemplatesDto> {
    return this.http.post<IDiscountTemplatesDto>(`${this.url}UpdateDiscountTemplate`, payload, { headers: this.headers }).pipe(
      map(response => response)
    )
  }

  GetDiscountTemplates(payload: IPagedDiscountTemplateResultRequestDto) {
    return this.http.post<PagedResultDto<IDiscountTemplatesDto>>(this.url + 'GetDiscountTemplates', payload, { headers: this.headers });
  }

  GetDiscountTemplate(id: number): Observable<IDiscountTemplatesDto> {
    return this.http.get<IDiscountTemplatesDto>(`${this.url}GetDiscountTemplate/${id}`, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  DeleteDiscountTemplate(id: number) {
    return this.http.delete(`${this.url}DeleteDiscountTemplate/${id}`, { headers: this.headers }).pipe(
      map(response => response)
    )
  }
  CreateGeneralDiscountTemplate(CreateGeneralProductDto: ICreateGeneralDiscountTemplatesDto) {
    return this.http.post<ICreateGeneralDiscountTemplatesDto>(this.generalurl + 'CreateDiscountTemplateGeneral',
      CreateGeneralProductDto, { headers: this.headers })
  }
  UpdateDiscountTemplateGeneral(UpdateGeneralProductDto: IUpdateGeneralDiscountTemplatesDto) {
    return this.http.post<IUpdateGeneralDiscountTemplatesDto>(this.generalurl + 'UpdateDiscountTemplateGeneral',
      UpdateGeneralProductDto, { headers: this.headers })
  }
  GetDiscountTemplateGenerals(payload: IPagedGeneralDiscountTemplateResultRequestDto) {
    return this.http.post<IPagedGeneralDiscountTemplateResultRequestDto>(this.generalurl + 'GetDiscountTemplateGenerals',
      payload, { headers: this.headers })
  }




  // /Customized

  GetAllDiscountTemplateCustomized(payload: IPagedCustomizedDiscountTemplateResultRequestDto) {
    return this.http.post<IPagedCustomizedDiscountTemplateResultRequestDto>(this.customurl + 'GetAllDiscountTemplateCustomized',
      payload, { headers: this.headers })
  }
  GetDiscountTemplateCustomizedById(id: number) {
    return this.http.get<IPagedCustomizedDiscountTemplateResultRequestDto>(this.customurl + `GetDiscountTemplateCustomized/${id}`,
     { headers: this.headers })
  }
  CreateDiscountTemplateCustomized(CreateDiscountProductDto: ICreateCustomizedDiscountTemplatesDto) {
    return this.http.post<ICreateCustomizedDiscountTemplatesDto>(this.customurl + 'CreateDiscountTemplateCustomized',
      CreateDiscountProductDto, { headers: this.headers })
  }
  UpdateDiscountTemplateCustomized(UpdateCustomizedProductDto: IUpdateCustomizedDiscountTemplatesDto) {
    return this.http.post<IUpdateCustomizedDiscountTemplatesDto>(this.customurl + 'UpdateDiscountTemplateGeneral',
      UpdateCustomizedProductDto, { headers: this.headers })
  }
  DeleteDiscountTemplateCustomized(id: number) {
    return this.http.post(`${this.customurl}DeleteDiscountTemplateCustomized/${id}`, null,{ headers: this.headers }).pipe(
      map(response => response)
    )
  }


  //Ding
  GetCountries() {
    // var headers1 = new HttpHeaders()
    //   .set('Content-Type', 'application/json; charset=utf-8')
    //   .set('Authorization', `Bearer ${this.Token}`);

    return this.http.get(this.dingUrl + 'GetCountries',
      { headers: this.headers })
  }
  GetProviders(iso) {
    return this.http.post(this.dingUrl + 'GetProviders?countryIso=' + iso,null,
      { headers: this.headers })
  }
  GetProvidersByPhoneNumber(phone,iso) {
    return this.http.post(this.dingUrl + 'GetProviders?countryIso='+iso+'&mobileNumber=' + phone,null,
      { headers: this.headers })
  }
  GetProducts(input) {
    return this.http.post(this.dingUrl + 'GetProducts', input,
      { headers: this.headers })
  }
  EstimatePrice(EstimatePriceDTO: any) {
    return this.http.post(this.dingUrl + 'EstimatePrice',
      EstimatePriceDTO, { headers: this.headers })
  }

  //Products
  GetActiveProducts() {
    return this.http.post(this.productUrl + 'GetActiveProducts',null,
      { headers: this.headers })
  }
}


